/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { a11y } from '@blend/consumer-components';

const styles = StyleSheet.create({
  errorText: {
    marginLeft: 5,
    lineHeight: 1.5,
    fontSize: 14,
  },
});

export namespace ErrorMessage {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {}
}

export const ErrorMessage: React.SFC<ErrorMessage.Props> = ({ children, ...htmlProps }) => (
  <>
    <span className={css(a11y.srOnly)}>Error: </span>
    <span className={css(styles.errorText)} {...htmlProps}>
      {children}
    </span>
  </>
);
